<div class="tax-details-form__form-container">
    <section>
        <form [formGroup]="taxDetailsForm" (ngSubmit)="onSubmit(f)" #f="ngForm">
            <h4>Change your tax details</h4>
            <br>
            <div class="tax-details-form__form-container-row">
                <h5 class="icon-header secondary-header-text medium-element-margin--bottom" for="marginalTaxRate">Resident
                    withholding tax (RWT)
                    <i class="material-icons primary-accent" [popper]="taxRateHelp" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true"
                        [popperApplyClass]="'popper_content'" [popperApplyArrowClass]="'popper_arrow'">help</i>
                </h5>
                <div *ngIf="(!isInvestorProvidedTaxRateValid || !canUserSelectTaxRate)"
                    class="half-default-element-margin--bottom">
                    <div class="message-box message--warning">
                        <!-- <p [innerHTML]="dashboardOnboardingFeature.blurb"></p> -->
                        <p *ngIf="canUserSelectTaxRate">Your previously provided tax rate doesn't match the available
                            tax rates for your situation.
                            <br>Choose one of the available tax rates in the selector below.
                        </p>
                        <p *ngIf="!canUserSelectTaxRate">{{userCannotSelectTaxrateDescriptionText}}
                        </p>
                    </div>
                </div>
                <mat-form-field class="default-form-input-container" appearance="outline">
                    <span class="tax-details-form__icon"><i class="material-icons">lock</i></span>
                    <mat-select formControlName="marginalTaxRate" placeholder="Select Tax Rate" disableOptionCentering>
                        <mat-option *ngFor="let k of (RWTTaxRates$ | async)" [value]="k.value">{{ k.key }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error
                    *ngIf="taxDetailsForm.controls['marginalTaxRate'].touched && taxDetailsForm.controls['marginalTaxRate'].errors?.required">
                    Tax rate is required
                </mat-error>
                <popper-content #taxRateHelp>
                    <p>
                        Select your tax rate that will apply for withholding tax when we pay you interest.
                        For further info visit the <a href="http://www.ird.govt.nz" target="_blank">Inland Revenue</a>
                        website.
                    </p>
                </popper-content>
            </div>
            <div class="tax-details-form__form-container-row">
                <h5 class="icon-header secondary-header-text medium-element-margin--bottom" for="pir">Prescribed investor rate(PIR)
                    <i class="material-icons primary-accent" [popper]="pirHelp" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperApplyClass]="'popper_content'"
                        [popperApplyArrowClass]="'popper_arrow'">help</i>
                </h5>
                <mat-form-field class="default-form-input-container" appearance="outline">
                    <span class="tax-details-form__icon"><i class="material-icons">lock</i></span>
                    <input matInput formControlName="pir" readonly>
                </mat-form-field>
                <popper-content #pirHelp>
                <p [innerHTML]="taxDetailsUpdateMessage"></p>
                </popper-content>
            </div>
            <div class="tax-details-form__form-container-row">
                <h5 class="icon-header secondary-header-text medium-element-margin--bottom" for="taxResidency">Country of Tax Residence
                    <i class="material-icons primary-accent" [popper]="taxResidencyHelp" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperApplyClass]="'popper_content'"
                        [popperApplyArrowClass]="'popper_arrow'">help</i>
                </h5>
                <mat-form-field class="default-form-input-container" appearance="outline">
                    <span class="tax-details-form__icon"><i class="material-icons">lock</i></span>
                    <input matInput formControlName="taxResidency" readonly>
                </mat-form-field>
                <popper-content #taxResidencyHelp>
                    <p [innerHTML]="taxDetailsUpdateMessage"></p>
                </popper-content>
            </div>
            <div *ngIf="updateFail" class="tax-details-form__form-container-row change-password-error-text-container">
                <p class="error-text">
                    <span class="error-text-arrow"></span>
                    Updating investor details failed
                </p>
            </div>
            <div *ngIf="updateSuccess" class="tax-details-form__form-container-row mat-form-success">
                <p class="success-text">
                    <i class="material-icons">
                        done
                    </i>
                    <span class="success-text-arrow"></span>
                    Updating investor details successful. Please be aware that some tax rates need a few days to be processed. You might experience therefore a delay in viewing your most up to date tax rate.
                </p>
            </div>
            <div class="tax-details-form-footer">
                <button (click)="onResetAndClose()"
                    class="a-rounded-button a-rounded-button--primary-outline">Cancel</button>
                <button disableRipple
                    class="a-rounded-button--primary a-rounded-button--medium form dialog__form-footer-button"
                    type="submit" [disabled]="!f.valid || !f.touched">{{ 'Save' }}</button>
            </div>
        </form>
    </section>
    <app-spinner *ngIf="isLoading" class="profile-spinner"></app-spinner>
</div>